// Helper per estrarre dati strutturati da un'offerta Noleggio LT
// (durata mesi, km/anno, prezzo mensile numerico) dai testi descrittivi.

const parseNumber = (s) => {
    if (!s) return null;
    // estrae tutte le cifre (rimuove separatori . e , ed ignora simbolo € e iva)
    const cleaned = String(s)
        .replace(/iva\s+esclusa/i, "")
        .replace(/iva\s+inclusa/i, "")
        .replace(/€/g, "")
        .replace(/\s/g, "")
        .replace(/[.,](?=\d{3}(?:\D|$))/g, "");
    const m = cleaned.match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
};

export const parseDurataMesi = (offer) => {
    const haystack = `${offer.title || ""} ${offer.subtitle || ""} ${offer.description || ""}`;
    const m = haystack.match(/(\d{2,3})\s*mesi/i);
    return m ? parseInt(m[1], 10) : null;
};

export const parseKmTotali = (offer) => {
    const haystack = `${offer.title || ""} ${offer.subtitle || ""} ${offer.description || ""}`;
    // cerca "120.000 km" / "40000 km" / "60.000km"
    const m = haystack.match(/([\d.,]{2,7})\s*km/i);
    if (!m) return null;
    const digits = m[1].replace(/[.,]/g, "");
    const n = parseInt(digits, 10);
    return isNaN(n) ? null : n;
};

export const parseKmAnnui = (offer) => {
    const tot = parseKmTotali(offer);
    const mesi = parseDurataMesi(offer);
    if (!tot || !mesi || mesi < 12) return null;
    return Math.round(tot / (mesi / 12));
};

export const parseRataMensile = (offer) => {
    return parseNumber(offer.monthly_price) || parseNumber(offer.price);
};

// Bucket helpers
export const DURATA_BUCKETS = [36, 48, 60];

export const KM_BUCKETS = [
    { key: "10k", label: "≤ 10.000 km/anno", min: 0, max: 10000 },
    { key: "20k", label: "10-20.000 km/anno", min: 10001, max: 20000 },
    { key: "30k", label: "20-30.000 km/anno", min: 20001, max: 30000 },
    { key: "30kplus", label: "30.000+ km/anno", min: 30001, max: Infinity },
];

export const RATA_BUCKETS = [
    { key: "200-400", label: "€ 200 - 400", min: 0, max: 400 },
    { key: "400-600", label: "€ 400 - 600", min: 401, max: 600 },
    { key: "600plus", label: "€ 600+", min: 601, max: Infinity },
];

export const matchesNltFilters = (offer, filters) => {
    if (filters.durata && filters.durata.length > 0) {
        const d = parseDurataMesi(offer);
        if (!d || !filters.durata.includes(d)) return false;
    }
    if (filters.km && filters.km.length > 0) {
        const k = parseKmAnnui(offer);
        if (!k) return false;
        const ok = filters.km.some((bk) => {
            const b = KM_BUCKETS.find((x) => x.key === bk);
            return b && k >= b.min && k <= b.max;
        });
        if (!ok) return false;
    }
    if (filters.rata && filters.rata.length > 0) {
        const r = parseRataMensile(offer);
        if (!r) return false;
        const ok = filters.rata.some((bk) => {
            const b = RATA_BUCKETS.find((x) => x.key === bk);
            return b && r >= b.min && r <= b.max;
        });
        if (!ok) return false;
    }
    return true;
};
